import CancelScheduleSendIcon from '@mui/icons-material/CancelScheduleSend';

const icons = {
  CancelScheduleSendIcon
};

const cancellation = {
  id: 'cancellationapproval',
  type: 'group',
  children: [
    {
      id: 'cancellationapproval',
      title: 'Cancellation Approval',
      type: 'item',
      url: '/cancellation-approval',
      icon: icons.CancelScheduleSendIcon,
    }
  ]
};

export default cancellation;
